import { css } from 'lit';

/**
 * Shared styles for the tab components
 */
export const tabsStyles = css`
  :host {
    display: block;
  }

  .tabs {
    position: relative;
    display: flex;
    margin-bottom: 0;
    padding-right: 0;
    padding-left: var(--spacing-16, 16px);
    overflow-x: auto;
    justify-content: left;
    font-size: 1.6rem;
    list-style: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
    border-bottom: 1px solid var(--gray-pale, #e6e6e6);
    background: var(--surfaces-surface-light, #ffffff);
    border-radius: 8px;
  }

  .tabs--centered {
    justify-content: center;
  }

  .tabs::-webkit-scrollbar {
    display: none;
  }

  .tabs__item {
    position: relative;
    display: flex;
    margin-right: var(--spacing-16, 16px);
  }

  .tabs__trigger {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    padding: var(--spacing-12, 12px) 0;
    color: var(--color-text-default, #333);
    cursor: pointer;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    font-size: 1.4rem;
    font-weight: 500;
    text-decoration: none;
    white-space: nowrap;
  }

  .tabs__trigger--default:hover:not(.tabs__trigger--active):not([disabled]) {
    color: var(--theme-color2, #0077cc);
    border-bottom-color: var(--theme-color2-light, #4d94db);
  }

  .tabs__trigger:focus {
    outline: none;
  }

  .tabs__trigger:focus-visible {
    box-shadow: 0 0 0 2px var(--theme-color2-light, #4d94db);
    border-radius: 4px;
  }

  .tabs__trigger--active {
    color: var(--theme-color2, #0077cc);
    border-bottom-color: var(--theme-color2, #0077cc);
    font-weight: 600;
  }

  .tabs__trigger[disabled] {
    color: var(--color-text-disabled, #999);
    cursor: not-allowed;
    opacity: 0.7;
  }

  .tabs__counter {
    display: inline-flex;
    padding: 0 0.5em;
    min-width: 2em;
    height: 2em;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    vertical-align: middle;
    color: var(--white, #fff);
    border-radius: 1em;
    background-color: var(--theme-color2, #0077cc);
    margin-left: 0.5em;
  }

  .tab-content {
    padding-top: var(--spacing-04, 4px);
  }
`;

export const tabStyles = css`
  :host {
    display: block;
    width: 100%;
  }

  :host(:not([active])) {
    display: none;
  }

  .tab-content {
    background-color: var(--color-background, #fff);
  }

  /* Add specific styling for slotted content */
  ::slotted(*) {
    margin: 0;
  }
`;
